import { useStoreContext } from '#app/store'
import { AppNavigation } from './app-navigation'

export function Header({ isAdmin = false }: { isAdmin?: boolean }) {
	const selectedCount = useStoreContext(s => s.selectedPlotIds.length)
	return <AppNavigation selectedCount={selectedCount} isAdmin={isAdmin} />
}
